// extracted by mini-css-extract-plugin
module.exports = {"tagsContainer":"blog-tags_tagsContainer__q3hP5"};